export const getOidcStorageKey = () => {
    const authSettings = JSON.parse(localStorage.getItem('authSettings') as string);
    if (authSettings) {
        return `oidc.user:${authSettings.auth_server}:${authSettings.client_id}`;
    }
    return null;
};

export const getOidcInfo = () => {
    const key = getOidcStorageKey();
    if (key) {
        const oidc = JSON.parse(localStorage.getItem(key) as string);
        return oidc;
    }
    return null;
};

export const getToken = () => {
    const oidc = getOidcInfo();
    if (oidc) {
        return oidc.id_token;
    }
    return null;
};

const getDay = (date: any) => {
    if (!date) return '';
    return `${new Date(date)?.getDate()}`;
};

const getValue = (price: any) => {
    if (Number.isNaN(price)) return 0;
    return Number(price).toFixed(2);
};

const getNameAndValueArr = (history: any) =>
    history.map((day: any) => ({
        name: getDay(day?.date),
        value: getValue(day.priceUsd),
    }));

export const getWeekChartData = (cryptoHistory: any) => {
    if (!cryptoHistory) return null;

    const weekChartDataArr = cryptoHistory?.map((item: any) => ({
        currency: item?.currency,
        history: getNameAndValueArr(item?.history.slice(7, item?.history.length)),
    }));

    return Object.fromEntries(weekChartDataArr.map((item: any) => [item.currency, item.history]));
};

export const getShortCryptoAddress = (value: any) => `${value.slice(0, 5)}...${value.slice(-3)}`;

export const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString('en-CA');
    const formattedTime = date.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    });
    return `${formattedDate.replace(/-/g, '/')}, ${formattedTime}`;
};

/**
 * Extracts a user-facing message from an arbitrary error value. Prefers the
 * API's structured error body (`error.response.data.message`), falls back to
 * the JS Error's `.message`, then to a String() of the value. Use this in
 * mutation catch blocks so admins see "Course slug already exists" instead
 * of "Request failed with status code 409".
 */
export const extractErrorMessage = (e: unknown): string => {
    if (typeof e === 'object' && e !== null) {
        const r = e as { response?: { data?: { message?: string } }; message?: string };
        return r.response?.data?.message ?? r.message ?? 'Unknown error';
    }
    return String(e);
};
